import Cookies from 'js-cookie'

const TokenKey = 'catarc_infoSysSid'
const langKey = "lang";
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getIe8n() {
  const result = localStorage.getItem(langKey);
  if (result) {
    return result;
  } else {
    return "";
  }
}
export function setIe8n(lang) {
  removeIe8n();
  if (lang) {
    localStorage.setItem(langKey, lang);
  }
}
export function removeIe8n() {
  if (getIe8n()) {
    localStorage.removeItem(langKey);
  }
}
